import React, { Component } from 'react';
import { Field } from 'formik';
import { withAsyncActions } from 'react-async-client';
import * as yup from 'yup';

import ModalForm, { modalFormPropTypes } from 'components/common/ModalForm';
import Input from 'components/common/form/Input';
import {
    postRegion,
    putRegion,
    formAutoOptions,
} from 'actions/asyncActions';

const validationSchema = yup.object().shape({
    name: yup.string().trim().required(),
});

@withAsyncActions({
    postAction: postRegion,
    putAction: putRegion
}, formAutoOptions)
export default class CityModal extends Component {
    static propTypes = modalFormPropTypes;

    renderForm = formProps => {
        return (
            <div>
                <Field
                    name='name'
                    component={Input}
                    label='Название:'
                    placeholder='Введите название' />
            </div>
        );
    }

    render() {
        return (
            <ModalForm
                {...this.props}
                createTitle={'Добавить регион'}
                editTitle={'Редактировать регион'}
                validationSchema={validationSchema}
                renderForm={this.renderForm}
            />
        );
    }
}
